import { render } from "./TeacherGroupsView.vue?vue&type=template&id=508d2f4a"
import script from "./TeacherGroupsView.vue?vue&type=script&lang=js"
export * from "./TeacherGroupsView.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TeacherGroupsView.vue?vue&type=style&index=0&id=508d2f4a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__